import React from "react";

const DefaultQuestionBody = () => {
	return (
	  <div className="ui input" style={{ display: "flex" }}>
			<input disabled={true} />
	  </div>
	);
};

export default DefaultQuestionBody;